// Library Methods
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

// Config
import { priorityLanguageMap } from "src/config/languages";

const AdditionalLinks = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  return (
    <Box display="flex" flexDirection="column" gap="6px">
      <Typography fontWeight={600}>{t("Need More Resources?")}</Typography>
      <ul
        style={{
          listStyleType: "disc",
          paddingInlineStart: "16px",
          margin: 0,
        }}
      >
        <li>
          <Typography>
            {t("Read our")}{" "}
            <Link
              to={
                currentLang === "fr"
                  ? "http://retinalogik-21440877.hubspotpagebuilder.com/fr-ca/rl-2026-fclinic-start-9x7k2-58864abc-8bb5-42e4-bc8c-520547d440r"
                  : "https://retinalogik-21440877.hubspotpagebuilder.com/en-ca/rl-2026-clinic-start-9x7k2"
              }
              target="_blank"
              style={{
                fontWeight: 600,
                color: theme.palette.mode === "dark" ? "#202338" : "#E2772E",
                textDecoration: "underline",
              }}
            >
              {t("Getting Started Guide")}
            </Link>
          </Typography>
        </li>
        <li>
          <Typography>
            {t("Watch our")}{" "}
            <Link
              to="/knowledge-hub/tutorial-videos"
              target="_blank"
              style={{
                fontWeight: 600,
                color: theme.palette.mode === "dark" ? "#202338" : "#E2772E",
                textDecoration: "underline",
              }}
            >
              {t("tutorial videos")}
            </Link>
          </Typography>
        </li>
        <li>
          <Typography>
            {t("Or consult our")}{" "}
            <Link
              to="/knowledge-hub/operating-manual/publication-information"
              target="_blank"
              style={{
                fontWeight: 600,
                color: theme.palette.mode === "dark" ? "#202338" : "#E2772E",
                textDecoration: "underline",
              }}
            >
              {t("operating manual")}
            </Link>
          </Typography>
        </li>
      </ul>
    </Box>
  );
};

export default AdditionalLinks;
